<template>
  <form id="lang-form" method="post" class="text-white md:pt-8 px-2 w-full mb-12">
    <input type="hidden" name="_token" :value="csrf">
    <div class="flex flex-col items-start">
      <label for="lang">{{ $t('Language') }}</label>
      <select name="language" id="lang-selector" class="text-black w-full" v-model="language" v-on:change="handleLanguageChange">
        <option value="da" :selected="language ==='da'">Danish</option>
        <option value="en" :selected="language === 'en'">English</option>
        <option value="de" :selected="language === 'de'">German</option>
        <option value="pl" :selected="language === 'pl'">Polish</option>
      </select>
    </div>
  </form>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    currentLocale: 'en',
  },

  data() {
    return {
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      language: 'en'
    }
  },

  mounted() {
    this.language = this.currentLocale;
  },

  methods: {
    async handleLanguageChange() {
      await axios.post('/preferences/language', {
        language: this.language,
      }).then(response => {
        window.location.reload();
      })
    }
  }
}
</script>